import { render, staticRenderFns } from "./EsterilizacaoEnxoval.vue?vue&type=template&id=4eafa417&"
import script from "./EsterilizacaoEnxoval.vue?vue&type=script&lang=js&"
export * from "./EsterilizacaoEnxoval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports